import styled from 'styled-components'

export const ButtonLabel = styled.div`
	display: flex;
	align-items: center;
	column-gap: 8px;
`
